const target = {
    user: 'Benutzer',
    userAndPw: '@:target.username und @:input.password',
    username: 'Benutzername'
}
export default target